import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { ModalVentasComponent } from 'src/app/reporte/modal-ventas/modal-ventas.component';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { EditEmpresaService } from 'src/app/empresa/services/edit-empresa.service';
import { mensajeCertificado } from '../assets/dataMensaje';
import { RegistroService } from '../../registro.service';
import { CargaEmpresasService } from 'src/app/services/carga-empresas.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-report-page',
    templateUrl: './report-page.component.html',
    styleUrls: ['./report-page.component.css'],
})
export class LoadAndQueryReportPageComponent {
    years: number[] = [];
    months: { value: number; name: string }[] = [
        { value: 1, name: 'Enero' },
        { value: 2, name: 'Febrero' },
        { value: 3, name: 'Marzo' },
        { value: 4, name: 'Abril' },
        { value: 5, name: 'Mayo' },
        { value: 6, name: 'Junio' },
        { value: 7, name: 'Julio' },
        { value: 8, name: 'Agosto' },
        { value: 9, name: 'Septiembre' },
        { value: 10, name: 'Octubre' },
        { value: 11, name: 'Noviembre' },
        { value: 12, name: 'Diciembre' },
    ];
    reports: any[];
    selectedFile: File | undefined;

    filesend: boolean;
    fileUploaded: boolean;
    accessToken = '';

    selectedMonth: number;
    selectedYear: number;

    ultimoObjetoCreado;
    empresaSeleccionada;

    private apiUrl: string = environment.apiSiriUrl;
    @ViewChild('reporteIndividual', { static: false })
    modalVentas: ModalVentasComponent;
    @ViewChild('modalLoadReport') modalLoadReport: ElementRef;
    lastReport: any;
    showCertificados = false;

    showCertificates() {
        this.showCertificados = true;
    }
    constructor(
        private router: Router,
        private el: ElementRef,
        private modalService: NgbModal,
        private keycloakService: KeycloakService,
        private http: HttpClient,
        private editarService: EditEmpresaService,
        private registroService: RegistroService,
        private cargaEmpresasService: CargaEmpresasService,
        private translate: TranslateService
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
    }

    async ngOnInit() {
        this.empresaSeleccionada = await firstValueFrom(
            this.cargaEmpresasService.obtenerEmpresaSeleccionada()
        );
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();
        this.selectedYear = currentYear;
        const years = [];
        this.fileUploaded = false;

        for (let i = currentYear; i >= currentYear - 10; i--) {
            years.push(i);
        }
        this.years = years;
        this.selectedMonth = currentMonth + 1;
        this.historyReport();

        this.keycloakService.getToken().then((token) => {
            this.accessToken = token;
        });

        await this.cargarReportePendienteHibrido();

        this.translate
            .get('reporte.alertaIngreso')
            .subscribe((translatedText: string) => {
                Swal.fire('Recuerda', translatedText, 'info');
            });
    }

    async continuarReporte() {
        //Validar si el usuario descargo el instructivo de reportes
        const puedeContinuar = await this.validarDescargaInstructivo();

        if (!puedeContinuar) {
            return;
        }
        this.router.navigate([`reporte-ventas`]);
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            const allowedExtensions = /(\.xlsx)$/i;

            if (!allowedExtensions.exec(file.name)) {
                Swal.fire(
                    'Error con el archivo',
                    'Por favor, selecciona un archivo con extensión .xlsx',
                    'warning'
                );
                input.value = '';
            } else {
                this.selectedFile = file;
            }
        }
    }

    async reporteManual() {
        //Validar si el usuario descargo el instructivo de reportes
        const puedeContinuar = await this.validarDescargaInstructivo();

        if (!puedeContinuar) {
            return;
        }
        this.modalVentas.viewReport();
    }
    enviar() {
        this.modalVentas.closeReport();
    }

    getFileSize(size: number): string {
        const fileSizeInKB = size / 1024;
        return fileSizeInKB.toFixed(2) + ' KB';
    }

    historyReport() {
        this.http
            .get(
                `${this.apiUrl}reporte/empresa-actual/${this.registroService.empresaSelected}/${this.selectedYear}/${this.selectedMonth}?state=Finalizado`
            )
            .subscribe(
                (response: any[]) => {
                    if (response.length > 0) {
                        response.sort(
                            (a, b) =>
                                new Date(b.fechaRegistro).getTime() -
                                new Date(a.fechaRegistro).getTime()
                        );
                        this.lastReport = response[0];
                    } else {
                        this.lastReport = {};
                    }
                    this.reports = response;
                },
                (error) => {
                    console.error('Error al descargar los reportes', error);
                }
            );
    }

    /**
     * Maps a period number mapping to a month name.
     * @param period The period number (1-12)
     * @returns The name of the month in Spanish, or empty string if invalid.
     */
    mapPeriodToMonthName(period: string | number): string {
        const periodNum =
            typeof period === 'string' ? parseInt(period, 10) : period;
        const monthObj = this.months.find((m) => m.value === periodNum);
        return monthObj ? monthObj.name : '';
    }

    async downloadReport() {
        try {
            //Validar si el usuario descargo el instructivo de reportes
            const puedeContinuar = await this.validarDescargaInstructivo();

            if (!puedeContinuar) {
                return;
            }
            console.log(
                `${this.apiUrl}reporte/descargar-planilla/${this.registroService.nitEmpresaSelected}`
            );
            const responseBlob = await lastValueFrom(
                this.http.get(
                    `${this.apiUrl}reporte/descargar-planilla/${this.registroService.nitEmpresaSelected}`,
                    { responseType: 'blob' }
                )
            );

            saveAs(responseBlob, 'planilla-siriagro.xlsx');
        } catch (error: any) {
            if (error.status === 412 && error.error instanceof Blob) {
                const errorText = await error.error.text();
                let mensaje = 'Datos erróneos, revisa el archivo';

                try {
                    const errorJson = JSON.parse(errorText);
                    mensaje = errorJson.message || mensaje;
                } catch {
                    mensaje = errorText || mensaje;
                }

                Swal.fire({
                    title: 'No es posible descargar la plantilla',
                    text: mensaje,
                    icon: 'warning',
                });
            } else {
                console.error('Error al descargar la plantilla', error);
                throw error;
            }
        }
    }

    mostrarTexto() {
        this.translate
            .get('reporte.alertaAyuda')
            .subscribe((translatedText: string) => {
                Swal.fire('', translatedText, 'info');
            });
    }

    async descargarCertificado() {
        const url = `${this.apiUrl}certificado`;
        try {
            //Validar si el usuario descargo el instructivo de reportes
            const puedeContinuar = await this.validarDescargaInstructivo();

            if (!puedeContinuar) {
                return;
            }

            const empresaActual =
                await this.editarService.getEmpresaActual('agente-vigilado');
            const mensaje = mensajeCertificado(empresaActual, this.lastReport);

            const agenteVigilado = {
                mensaje: mensaje,
            };

            this.http
                .post(url, agenteVigilado, { responseType: 'blob' })
                .subscribe(
                    (blob: Blob) => {
                        saveAs(blob, 'certificado.pdf');
                    },
                    (error) => {
                        console.error(
                            'Error al descargar el certificado:',
                            error
                        );
                    }
                );
        } catch (error) {
            console.error(
                'Error al obtener la información de la empresa:',
                error
            );
        }
    }

    async openMassUploadModal(content: any) {
        //Validar si el usuario descargo el instructivo de reportes
        const puedeContinuar = await this.validarDescargaInstructivo();

        if (!puedeContinuar) {
            return;
        }
        this.filesend = false;
        this.fileUploaded = false;
        this.selectedFile = undefined;
        this.modalService.open(content);
    }

    saveMassUpload() {
        if (this.selectedFile) {
            const formData = new FormData();
            formData.append('file', this.selectedFile);

            this.http
                .post(
                    `${this.apiUrl}reporte/carga-masiva/${this.registroService.empresaSelected}/${this.registroService.nitEmpresaSelected}/${this.registroService.correoCorporativo}`,
                    formData
                )
                .subscribe(
                    (response: any) => {
                        console.log('response ', response);
                        if (response.statusCode === 206) {
                            this.fileUploaded = true;
                            this.filesend = false;
                            Swal.fire(`${response.message}`, '', 'warning');
                        } else {
                            console.log('Archivo subido con éxito', response);
                            this.fileUploaded = false;
                            this.filesend = true;
                        }
                    },
                    (e) => {
                        this.filesend = false;
                        this.fileUploaded = false;
                        console.error('Error con archivo ', e);
                        if (e.error.statusCode == 412) {
                            this.fileUploaded = false;
                            this.filesend = false;
                            Swal.fire(
                                'Datos erróneos, revisa el archivo',
                                e.error.message,
                                'warning'
                            );
                            this.closeMassUploadModal();
                        } else if (typeof e.error.error === 'object') {
                            Swal.fire(
                                'Error al subir el archivo',
                                ' ',
                                'warning'
                            );
                        } else {
                            Swal.fire(
                                'Error al subir el archivo',
                                e.error.error,
                                'warning'
                            );
                        }
                        this.closeMassUploadModal();
                    }
                );
        }
    }

    replaceFile() {
        if (this.selectedFile) {
            const formData = new FormData();
            formData.append('file', this.selectedFile);
            this.http
                .post(
                    `${this.apiUrl}reporte/carga-masiva/${this.registroService.empresaSelected}/${this.registroService.nitEmpresaSelected}/${this.registroService.correoCorporativo}?overwrite=true`,
                    formData
                )
                .subscribe(
                    (response: any) => {
                        this.fileUploaded = false;
                        this.filesend = true;
                    },
                    (e) => {
                        this.fileUploaded = false;
                        console.log(
                            'Error al subir el archivo reemplazo  ',
                            e.error
                        );
                        if (e.error.statusCode == 412) {
                            console.log('status 412 ');
                            this.fileUploaded = false;
                            this.filesend = false;
                            Swal.fire(
                                'Datos erróneos, revisa el archivo',
                                e.error.message,
                                'warning'
                            );
                            this.closeMassUploadModal();
                        } else if (e.error.statusCode === 401) {
                            Swal.fire({
                                title: 'Acción no permitida',
                                text: e.error.message,
                                icon: 'warning',
                                confirmButtonText: 'Aceptar',
                            }).then((result) => {
                                if (result.isConfirmed || result.isDismissed) {
                                    this.closeMassUploadModal();
                                }
                            });
                        } else if (typeof e.error.error === 'object') {
                            Swal.fire(
                                'Error al subir el archivo',
                                ' ',
                                'warning'
                            );
                        } else {
                            Swal.fire(
                                'Error al subir el archivo',
                                e.error.error,
                                'warning'
                            );
                        }
                        this.closeMassUploadModal();
                    }
                );
        }
    }

    closeMassUploadModal() {
        this.fileUploaded = false;
        this.historyReport();
        this.modalService.dismissAll();
    }

    async irConsultaReportes() {
        const puedeContinuar = await this.validarDescargaInstructivo();

        if (!puedeContinuar) {
            return;
        }

        this.router.navigate(['/reporte-filtro-fecha']);
    }

    async downloadInstructive() {
        try {
            const pdf = await lastValueFrom(
                this.http.get(`${this.apiUrl}reporte/descargar-instructivo`, {
                    responseType: 'blob',
                })
            );

            saveAs(pdf, 'Buenas_practicas_instructivo.pdf');
        } catch (error) {
            console.error('Error al descargar el instructivo', error);

            Swal.fire({
                title: 'Error',
                text: 'No fue posible descargar el instructivo. Inténtalo nuevamente más tarde.',
                icon: 'error',
            });
        }
    }

    async validarDescargaInstructivo(): Promise<boolean> {
        try {
            const descargoInstructivo = await lastValueFrom(
                this.http.get<boolean>(
                    `${this.apiUrl}reporte/validar-descarga-instructivo`
                )
            );

            if (!descargoInstructivo) {
                Swal.fire({
                    title: 'Atención',
                    text: 'Antes de acceder a estas funcionalidades, es necesario descargar el instructivo.',
                    icon: 'warning',
                });
            }

            return descargoInstructivo;
        } catch (error) {
            console.error(
                'Error al validar la descarga del instructivo',
                error
            );

            Swal.fire({
                title: 'Error',
                text: 'No fue posible validar la descarga del instructivo.',
                icon: 'error',
            });

            return false;
        }
    }

    /**
     * Híbrido: primero busca en sesión (rápido), si no hay consulta el backend.
     * Si el backend devuelve un pendiente, lo cachea en sesión para la próxima.
     */
    private async cargarReportePendienteHibrido(): Promise<void> {
        const idEmpresa =
            this.registroService.empresaSelected ??
            this.empresaSeleccionada?.id;

        if (!idEmpresa) {
            this.ultimoObjetoCreado = null;
            return;
        }

        // Intento en sesión
        const enSesion = this.registroService.listaReportesGuardados?.find(
            (r) => String(r.idEmpresa) === String(idEmpresa)
        );

        if (enSesion) {
            this.ultimoObjetoCreado = enSesion;
            return;
        }

        // Fallback al backend
        try {
            const pendiente = await lastValueFrom(
                this.http.get<any>(`${this.apiUrl}reporte/pendiente`, {
                    params: {
                        idEmpresa: String(idEmpresa),
                    },
                })
            );

            if (pendiente) {
                this.ultimoObjetoCreado = pendiente;

                // Cachea la referencia ligera en sesión para próximas visitas
                this.registroService.listaReportesGuardados = [
                    ...(this.registroService.listaReportesGuardados ?? []),
                    {
                        idEmpresa: pendiente.idEmpresa ?? idEmpresa,
                        id_reporte_guardado: pendiente.id,
                    },
                ];
            } else {
                this.ultimoObjetoCreado = null;
            }
        } catch (error) {
            console.error('Error consultando último reporte pendiente:', error);
            this.ultimoObjetoCreado = null;
        }
    }
}
